import { buildUserAnalyticsProperties } from 'src/store/initialization/initialization.operations';

export const ANONYMOUS_LAUNCHDARKLY_CONTEXT = Object.freeze({
    kind: 'user',
    key: 'anonymous',
    anonymous: true,
});

/**
 * Builds a LaunchDarkly user context from Redux state.
 * Returns null until a stable user key (email or user_id) is available.
 *
 * @param {object} state
 * @returns {object|null}
 */
export const buildLaunchDarklyUserContext = (state) => {
    const personalInfo = state.user?.personalInformation || {};
    const email = personalInfo.email || '';
    const key = email || personalInfo.user_id;

    if (!key) {
        return null;
    }

    const props = buildUserAnalyticsProperties(state);

    return {
        kind: 'user',
        key,
        ...(email ? { email } : {}),
        custom: {
            user_role: props.user_role || '',
            agency_id: props.agency_id || '',
            agency_type: props.agency_type || '',
            jurisdiction_id: props.jurisdiction_id || '',
            lyt_employee: props.lyt_employee === 'true',
        },
    };
};

/**
 * @param {object} state
 * @returns {object}
 */
export const resolveLaunchDarklyContextFromState = (state) => {
    const access = state.session?.access;
    const userContext = buildLaunchDarklyUserContext(state);

    if (access && userContext) {
        return userContext;
    }

    return ANONYMOUS_LAUNCHDARKLY_CONTEXT;
};
